<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout v-if="user.access_to_study_plan" column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon aria-hidden="true" translate="no">
                        <template #divider>
                            keyboard_arrow_left
                        </template>
                    </v-icon>
                    <a href="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                            {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </a>
                </v-breadcrumbs>
                <h1 class="section-title-main my-3 font-weight-regular">
                    {{ $t("Планирование обучения") }}
                </h1>
                <p v-if="!accesses">
                    В данном разделе вы можете оставить заявку на проведение обучающих вебинаров от сотрудников ООО «ЛЛК-Интернешнл».
                    <br>
                    Вебинар проводится онлайн. Продолжительность вебинара зависит от количества выбранных тем. Ориентировочное время 1,5-2 часа.
                    <br>
                    Для финального подтверждения заявки с Вами свяжутся дополнительно.
                </p>
                <v-tabs :value="get_plan_tab" @change="SET_CURRENT_TAB">
                    <v-tab
                        v-for="(tab, index) in get_plan_tabs"
                        :key="index"
                        class="study-plan__tab text-white"
                        active-class="study-plan__tab-active"
                    >
                        {{ $t(tab.title) }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items touchless :value="get_plan_tab">
                    <v-tab-item lazy>
                        <study-calendar />
                    </v-tab-item>
                    <v-tab-item lazy>
                        <study-requests />
                    </v-tab-item>
                </v-tabs-items>
            </v-layout>
            <div v-else class="pa-4">{{ $t("Доступ запрещён") }}</div>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import StudyCalendar from '@/components/view_blocks/Study_plan/Study_plan_calendar.vue';
import StudyRequests from '@/components/view_blocks/Study_plan/Study_plan_requests.vue';

export default {
  name      : 'Study',
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    StudyCalendar,
    StudyRequests,
  },
  computed: {
    ...mapGetters('study_plan', ['get_plan_tabs', 'get_plan_tab']),
    ...mapGetters('profile/user', [
      'user',
    ]),
    accesses() {
      if (this.user.role) {
        return !!this.user.role.managment_study_events.rights.length;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations('study_plan', ['SET_CURRENT_TAB']),
  },
};
</script>

<style lang="less">
@import url('../less/variables');

.study-plan__tab {
    background-color: #DEDEDE;
    & a {
        padding: 10px 16px;
    }
    &-active {
        background-color: @main-color;
        color: @additional-color-light;
    }
    &-active:hover {
        color: @additional-color-light;
    }
}
</style>
